import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toHandlerKey as _toHandlerKey, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b3ac6726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feature-list" }
const _hoisted_2 = { class: "feature-content" }
const _hoisted_3 = { class: "feature-title" }
const _hoisted_4 = { class: "feature-description" }
const _hoisted_5 = { class: "feature-switch" }
const _hoisted_6 = { class: "switch-label" }

import { ref, reactive, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import Card from '@/views/dashboard/_components/card/card.vue'
import CmForm from '@/components/cmForm/index.vue'
import {
  ActionType,
  FormActionType,
  FormItem,
  FormSize,
  FormSizeType,
  FormType,
} from '@/components/cmForm/types'
import {
  PolicyCommonService,
  SaveSettingsReq,
} from '../../../policy/policy-common.service'
import { PolicySettingType, PolicyType } from '../../../_enum/policy-type'
import { getIsRepeat } from '@/utils/tool'

type FormKey = 'process_infos'
type Form = {
  process_infos?: { path: string }[]
}

const SWITCH_OFF = 1
const SWITCH_ON = 2

/** 防御配置表单，组件内部维护，不依赖外部传入 */

export default /*#__PURE__*/_defineComponent({
  __name: 'defense-config',
  props: {
  hasPermission: {
    type: Boolean,
    default: false,
  },
},
  emits: ['handleConfig', 'featureChange'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const validatePath = (rule, value, callback) => {
  const reg =
    /^[a-zA-Z]:(\/|\\)(?:[^\/\\:*?"<>|\r\n]+(?:\/|\\)[^\/\\:*?"<>|\r\n]+)*[^\/\\:*?"<>|\r\n]+$/
  if (!reg.test(value)) {
    callback(new Error(t('ransomwareIncident.pathFormatError')))
  }
  callback()
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector([PolicyCommonService])
const groupPolicySettingsService = injector.get(PolicyCommonService)
const saveOrUpdateApi = groupPolicySettingsService.saveSettings.bind(
  groupPolicySettingsService,
)
const getByType = groupPolicySettingsService.getByType.bind(
  groupPolicySettingsService,
)

const formSize: FormSizeType = FormSize.Small
const formType = ref(FormActionType.Other)
const formRef = ref()
const visible = ref(false)
let formData: SaveSettingsReq = {} as SaveSettingsReq
const form = reactive<Form>({
  process_infos: [{ path: '' }],
})

/** 1 关闭，2 开启 */
const ransomWareProtectForm = ref<{ bait_switch: number; ransomware_protect_switch: number; [key: string]: unknown }>({
  bait_switch: SWITCH_ON,
  ransomware_protect_switch: SWITCH_ON,
})

const features = ref([
  {
    titleKey: 'ransomwareIncident.baitCapture',
    descriptionKey: 'ransomwareIncident.baitCaptureDesc',
    enabled: true,
    field: 'bait_switch' as const,
    hasLink: false
  },
  {
    titleKey: 'ransomwareIncident.batchTamperDetect',
    descriptionTextKey: 'ransomwareIncident.batchTamperDesc',
    linkTextKey: 'ransomwareIncident.trustedProcessManage',
    enabled: true,
    field: 'ransomware_protect_switch' as const,
    hasLink: true
  }
])

function syncFeaturesFromForm(form?: { bait_switch?: number; ransomware_protect_switch?: number }) {
  const data = form ?? ransomWareProtectForm.value
  if (!data) return
  features.value[0].enabled = data.bait_switch === SWITCH_ON
  features.value[1].enabled = data.ransomware_protect_switch === SWITCH_ON
}

const suffixTipContent = computed(() => `
    <strong>${t('ransomwareIncident.processPath')}：</strong>
    <div class='cm-ui-mt10'>${t('ransomwareIncident.pathTip1')}</div>
    <div class='cm-ui-mt10'>${t('ransomwareIncident.pathTip2')}</div>
    <div class='cm-ui-mt10 class='cm-ui-mb10''>${t('ransomwareIncident.pathTip3')}</div>
`)

const formColumns = reactive([
  {
    prop: 'process_infos',
    globalOpt: { required: true },
    hiddenAllLabel: true,
    tableOpt: { 'max-height': 400, bodyStyle: 'line-height: normal;padding: 6px', cardOpt: { style: 'margin-top: 7px' } },
    type: FormType.DynamicTable,
    colOpt: { span: 24 },
    plusText: t('ransomwareIncident.addProcess'),
    removeText: t('ransomwareIncident.remove'),
    removeOpt: { type: 'danger', underline: false },
    plusOpt: { style: 'margin-top:10px', type: 'primary', plain: true },
    rowAdd: (done: (row: { path: string }) => void) => done({ path: '' }),
    rowDel: (_row: unknown, done: () => void) => done(),
    columns: {
      path: {
        suffixTipOpt: { placement: 'top-start' },
        suffixTip: suffixTipContent.value,
        rules: [{ custom: { validator: validatePath } }],
        hiddenAllLabel: true,
        label: t('ransomwareIncident.processPath'),
      },
    },
  },
])

const handleConfig = () => {
  emits('handleConfig')
}

const handleProcessWhiteList = () => {
  visible.value = true
  getByTypeFun()
}

const getByTypeFun = async () => {
  const result = await getByType({
    type: ~~PolicySettingType.ransomWareProtect,
  }).catch()
  if (!result.data) return
  formData = result.data
  const strategy = JSON.parse(formData.strategy)
  const ransomwareprotect = {
    bait_switch: strategy.ransomwareprotect?.bait_switch ?? SWITCH_ON,
    ransomware_protect_switch: strategy.ransomwareprotect?.ransomware_protect_switch ?? SWITCH_ON,
    ...strategy.ransomwareprotect,
  }
  ransomWareProtectForm.value = ransomwareprotect
  syncFeaturesFromForm(ransomwareprotect)
  form.process_infos = strategy.ransomwareprotect?.whitelist?.map((item: string) => ({
    path: item,
  })) || [{ path: '' }]
}

const apiSubmit = async () => {
  if (getIsRepeat(form.process_infos.map((item) => item.path))) {
    return 'error'
  }
  const submitFormData = {
    strategy_type: PolicyType.ransomWareProtect,
    type: ~~PolicySettingType.ransomWareProtect,
    id: formData.id,
    name: t('ransomwareIncident.ransomwareProtection'),
    group_ids: [-1],
    bind_mode: 0,
    device_ids: [],
    strategy: JSON.stringify({
      ransomwareprotect: {
        ...ransomWareProtectForm.value,
        whitelist: form.process_infos.map((item) => item.path),
      },
    }),
  }
  return await saveOrUpdateApi(submitFormData).catch()
}

const handleSubmit: (
  valid: boolean,
  done: () => void,
) => Promise<void> = async (
  valid: boolean,
  done: (ok: boolean, message?: string) => void,
) => {
  if (!valid) return
  const result = await apiSubmit().catch(err => err)

  if (result === 'error') {
    done(false, t('ransomwareIncident.whitelistDuplicate'))
    return
  }
  const ok = result?.resp_common?.msg === 'ok'
  done(ok)
  !formData.id && getByTypeFun()
  visible.value = !ok
}

async function handleFeatureChange(feature: (typeof features.value)[number], index: number) {
  const value = feature.enabled ? SWITCH_ON : SWITCH_OFF
  ransomWareProtectForm.value = { ...ransomWareProtectForm.value, [feature.field]: value }
  emits('featureChange', feature, index)
  if (!formData?.id) return
  const submitFormData = {
    strategy_type: PolicyType.ransomWareProtect,
    type: ~~PolicySettingType.ransomWareProtect,
    id: formData.id,
    name: t('ransomwareIncident.ransomwareProtection'),
    group_ids: [-1],
    bind_mode: 0,
    device_ids: [],
    strategy: JSON.stringify({
      ransomwareprotect: ransomWareProtectForm.value,
    }),
  }
  await saveOrUpdateApi(submitFormData).catch()
}

onMounted(() => {
  syncFeaturesFromForm()
  props.hasPermission && getByTypeFun()
})

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Card, {
      title: _ctx.$t('ransomwareIncident.defenseConfig'),
      size: "first",
      class: "defense-config-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (feature, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "feature-item el-card"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t(feature.titleKey)), 1),
                _createElementVNode("p", _hoisted_4, [
                  (feature.hasLink)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t((feature as { descriptionTextKey?: string }).descriptionTextKey || '')) + " ", 1),
                        _createElementVNode("span", {
                          class: "link-text",
                          onClick: handleProcessWhiteList
                        }, _toDisplayString(_ctx.$t((feature as { linkTextKey?: string }).linkTextKey || '')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t((feature as { descriptionKey?: string }).descriptionKey || '')), 1)
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_switch, {
                  modelValue: feature.enabled,
                  "onUpdate:modelValue": ($event: any) => ((feature.enabled) = $event),
                  disabled: !__props.hasPermission,
                  "active-color": "var(--el-color-primary)",
                  "inactive-color": "var(--cm-color-text-placeholder)",
                  onChange: ($event: any) => (handleFeatureChange(feature, index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(feature.enabled ? _ctx.$t('ransomwareIncident.opened') : _ctx.$t('ransomwareIncident.closed')), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      title: _ctx.$t('ransomwareIncident.processWhitelistDialog'),
      formType: formType.value,
      "onUpdate:formType": _cache[4] || (_cache[4] = ($event: any) => ((formType).value = $event)),
      width: 650,
      "custom-class": "cm-virus-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(CmForm, _mergeProps({
          formSize: _unref(formSize),
          modelValue: form,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
          formOpt: { confirmText: _ctx.$t('ransomwareIncident.save') },
          ref_key: "formRef",
          ref: formRef,
          formColumns: formColumns
        }, {
          [_toHandlerKey(_unref(ActionType).Reset)]: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
        }, {
          onSubmit: handleSubmit,
          actionColOpt: { style: 'display:flex;justify-content:flex-end' }
        }), null, 16, ["formSize", "modelValue", "formOpt", "formColumns"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "formType"])
  ], 64))
}
}

})